import { Routes, Route } from 'react-router-dom';
import RouterAppAnimation from './RouterAppAnimation';

export default function RouterApp() {
    return(
        <>
            <Routes>
                <Route path="*" element={<RouterAppAnimation />} />
            </Routes>
        </>
    )
}
